import { Box, Button } from "@chakra-ui/react"
import { ChevronRightIcon } from "@pathwright/pathicons"
import InvalidVariable from "@pathwright/ui/src/components/variable-selector/InvalidVariable"
import Link from "@pathwright/ux/src/components/link/Link"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"

// Possibly handle nested keys in the future:
// const variableRe = /^([a-zA-Z_]+\.?(?=[a-zA-Z_]+)[a-zA-Z_]*)+$/i

// Currently only allowing flat key
const variableRe = /^[a-zA-Z_]+$/i

export const CustomVariable = ({ variable }) => {
  const { t } = useTranslate()

  if (!variableRe.test(variable)) {
    return <InvalidVariable variable={variable} />
  }

  return (
    <Box color="whitesmoke">
      <div>
        <strong style={{ whiteSpace: "nowrap" }}>
          {t("Custom variable")}:
        </strong>
      </div>
      {t(
        "be sure to setup values for your custom variables when editing certificate settings for your courses."
      )}{" "}
      <Link
        asChild
        variant="underline"
        href="https://help.pathwright.com/en/articles/9211185-award-a-certificate-of-completion"
      >
        <Button color="white">
          <span>Learn more</span>
          <ChevronRightIcon size="1em" />
        </Button>
      </Link>
    </Box>
  )
}

CustomVariable.displayName = "CustomVariable"
